module.exports = __webpack_public_path__ + "img/bar-chart-05.0e5e7153.svg";